import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { IParseProduct } from '../../models/quotations.models';

@Component({
  selector: 'app-duplicate-products-handler',
  templateUrl: './duplicate-products-handler.component.html',
  styleUrls: ['./duplicate-products-handler.component.scss']
})
export class DuplicateProductsHandlerComponent implements OnInit {

  baseUrl = environment.BASE_URL_API;
  placeholder: string = 'assets/icones/default-image-product.svg';
  // IDs of order lines selected to be deleted
  selectedOrderLineIds: Set<number> = new Set<number>();
  attemptedSubmit = false;

  constructor(private dialogRef: MatDialogRef<DuplicateProductsHandlerComponent>, @Inject(MAT_DIALOG_DATA) public data: IParseProduct[]) { }

  ngOnInit(): void {
  }

  save() {
    this.attemptedSubmit = true;
    if (!this.canConfirm) {
      return;
    }
    this.dialogRef.close(Array.from(this.selectedOrderLineIds));
  }

  cancel() {
    this.dialogRef.close();
  }

  onToggleSelection(product: IParseProduct, checked: boolean) {
    const id = product.order_line_id;
    if (typeof id !== 'number') {
      return;
    }
    if (checked) {
      this.selectedOrderLineIds.add(id);
    } else {
      this.selectedOrderLineIds.delete(id);
    }
  }

  isSelected(product: IParseProduct): boolean {
    const id = product.order_line_id;
    if (typeof id !== 'number') {
      return false;
    }
    return this.selectedOrderLineIds.has(id);
  }

  get canConfirm(): boolean {
    const total = this.data?.length ?? 0;
    const selected = this.selectedOrderLineIds.size;
    // Must select at least one duplicate to delete, but not all
    return selected > 0 && selected < total;
  }

}
